import SlideManager from "../slide-manager";
import LimitManager from "../../interactivity/limit-manager";

const Axes = ["x", "y", "z"];

class ScaleLimits {
    constructor(controls) {
        this._controls = controls;
        this._limitOnScaleThis = this._limitOnScale.bind(this);
        this._controls.events.addEventListener("change", this._limitOnScaleThis);
    }

    _limitOnScale({ action, object }) {
        if (action !== "scale") return;

        const slideIndex = SlideManager.activeSlide;
        const currentSlide = SlideManager.getSlide(slideIndex);
        const animData = currentSlide.animation[object.uuid];

        if (!animData && currentSlide.controls.interactionType !== "objectRotation") return;

        const cameraLimits = LimitManager.getObjectCameraLimits(slideIndex, object.uuid);
        const limit = cameraLimits.objectScaleLimitEnabled ? cameraLimits.objectScaleLimit : Infinity;

        for (let axis of Axes) {
            const scaleData = animData.scale[axis];
            const minScale = Math.max(scaleData / limit, 0.01);
            const maxScale = scaleData * limit;

            if (cameraLimits.objectScaleLimitEnabled && Q3.editMode && Q3.objectRotationControls === Q3.controls && (object.scale[axis] > maxScale || object.scale[axis] < minScale)) {
                const showSnackBar = (message) => {
                    clearTimeout(this.snackTimeout);
                    this.snackTimeout = setTimeout(() => {
                        Q3.showSnackBar(message);
                    }, 200);
                }

                showSnackBar("Zoom limit reached");
            }

            object.scale[axis] = Math.min(Math.max(minScale, object.scale[axis]), maxScale);
        }
    }
}

export default ScaleLimits;
